module.exports = __webpack_public_path__ + "img/flandre scarlet_sc1.962ee225.png";